import { leaseReleaseScript, leaseScript, membershipScript } from "./lease.js";
import {
  overwrittenCasScript,
  reclaimScript,
  releaseScript,
  resolveScript,
  windDownScript,
} from "./placement.js";
import {
  gcScript,
  heartbeatScript,
  mirrorScript,
  nsWorkersScript,
  registerScript,
} from "./registry.js";
import type { Script } from "./twins.js";

/** Every script def, for MemoryRedis's sha -> JS-twin table. */
export const allScripts: readonly Script.Def[] = [
  resolveScript,
  registerScript,
  reclaimScript,
  mirrorScript,
  heartbeatScript,
  nsWorkersScript,
  gcScript,
  windDownScript,
  leaseScript,
  membershipScript,
  releaseScript,
  overwrittenCasScript,
  leaseReleaseScript,
];
